import React from "react";
import { InlineSkeleton } from "@smartling/react-skeleton";

import * as styles from "./skeleton.module.css";

export function ProductNameSkeleton() {
    return (
        <div data-testid="productNameSkeleton" className={styles.container}>
            <InlineSkeleton className={styles.title} aria-label="Loading product info" />
            <InlineSkeleton className={styles.subtitle} />
        </div>
    );
}
